import React from "react";
import Card from "react-bootstrap/Card";

export const Disclaimer = () => {
    return (
        <>
            <div className="container-fluid mt-4">
                <Card className="mb-4 w-100">
                    <Card.Header as="h2" className="header-card">
                        <span>Disclaimer</span>
                    </Card.Header>
                    <Card.Body>
                        <Card.Text className="mb-1">
                            Thank you for visiting the Navajo Nation&apos;s
                            Department of Personnel Management website and
                            reviewing our privacy statement. Our website is
                            provided for informational purposes only. It is not
                            meant to be a contract of any type and should not be
                            treated as such by site visitors. This policy may
                            change at any time, without prior notice to any
                            visitor.
                        </Card.Text>

                        <Card.Text className="mb-1">
                            Our site does uses cookies for authorization
                            purposes. All information collected through
                            information volunteered in response to a survey,
                            online form for any other purpose, or communication
                            via e-mail will be used to respond to you. We do not
                            collect any personal information about you unless
                            you voluntarily provide it to us.
                        </Card.Text>

                        <Card.Text className="mb-1">
                            This site has many links to other websites,
                            including links to other sites operated by other
                            government agencies, nonprofit organizations, and
                            private businesses. If you are not comfortable with
                            this site, please disconnect at any time. When
                            linking to these other sites, this privacy policy
                            will no longer apply, and you will be subject to the
                            privacy policy of that new site.
                        </Card.Text>

                        <ul>
                            <li className="card-text bottom-space">
                                <strong> Telephone:</strong>
                                <Card.Text>(928) 357-6697</Card.Text>
                            </li>
                            <li className="card-text  bottom-space">
                                <strong> Mail:</strong>
                                <Card.Text>
                                    P.O. Box 7080, Window Rock, AZ, 86515
                                </Card.Text>
                            </li>
                            <li className="card-text  bottom-space">
                                <strong>
                                    {" "}
                                    This policy is effective on September 1,
                                    2026
                                </strong>
                            </li>
                        </ul>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
};
